import React from 'react';
import { Box, HStack, Menu, MenuButton, MenuList, MenuItem, Input, Button } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import useBeneficiaryMap from '../../hooks/useBeneficiaryMap';
import { MapView } from '../../GlobalComponent/MapView/MapView';
import { ColorLegend } from '../../GlobalComponent/ColorLegend/ColorLegend';
import { Company } from '../../Interfaces/Company';

interface BeneficiaryMapProps {
  companies: Company[];
  isActive?: boolean;
}

const BeneficiaryMap: React.FC<BeneficiaryMapProps> = ({ companies, isActive = true }) => {
  const {
    loading,
    filteredCompanies,
    selectedCompanyName,
    clusters,
    setSelectedCompany,
    searchTerm,
    setSearchTerm,
    isOpen,
    setIsOpen,
    inputRef,
  } = useBeneficiaryMap({ companies });

  return (
    <Box width={"98%"}>
      <HStack spacing={4} mb={4} align="start">
        <Menu isOpen={isOpen} onClose={() => setIsOpen(false)}>
          <MenuButton
            as={Button}
            rightIcon={<ChevronDownIcon />}
            onClick={() => setIsOpen(!isOpen)}
            width="300px"
            textAlign="left"
          >
            {selectedCompanyName || "Select a company"}
          </MenuButton>
          <MenuList maxH="300px" overflowY="auto">
            <Box p={2} onClick={(e) => e.stopPropagation()}>
              <Input
                ref={inputRef}
                placeholder="Search companies..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setTimeout(() => inputRef.current?.focus(), 0);
                }}
                onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => {
                  e.stopPropagation();
                  if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                    e.preventDefault();
                  }
                }}
                onFocus={(e) => e.stopPropagation()}
                size="sm"
                autoComplete="off"
              />
            </Box>
            {filteredCompanies.map((company) => (
              <MenuItem
                key={company._id}
                onClick={() => {
                  setSelectedCompany(company._id);
                  setSearchTerm("");
                  setIsOpen(false);
                }}
              >
                {company.companyName}
              </MenuItem>
            ))}
            {filteredCompanies.length === 0 && (
              <MenuItem isDisabled>
                No companies found
              </MenuItem>
            )}
          </MenuList>
        </Menu>
        {selectedCompanyName && (
          <ColorLegend items={[
            { color: 'red', label: 'Home Address' },
            { color: 'green', label: 'Work Address' },
            { color: 'blue', label: 'Other Address' },
            { color: 'purple', label: 'Mixed' },
          ]} />
        )}
      </HStack>

      {selectedCompanyName ? (!loading ? <MapView clusters={clusters} isActive={isActive} /> : <Box p={4}>Please select a company to view the map data.</Box>) : <Box p={4}>Please select a company to view the map data.</Box>}
    </Box>
  );
};

export default BeneficiaryMap;